module.exports = __webpack_public_path__ + "ff256642f75506b9d05eb28379fc05d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contacts/contacts-intro.jpg
// module id = 1210
// module chunks = 0